<template>
  <div class="menu-list bg-white dis-f align-center">
    <div
      v-for="(item, index) in menuData"
      :key="item.pagePath"
      class="flex1 dis-f align-center justify-center flex-column paddingh20 paddingv10"
      @click="switchRoute(item)"
    >
      <img
        :src="zIndex == index ? item.selIcon : item.icon"
        class="menu-icon"
      />
      <p
        class="fs-12 paddingt10"
        :class="zIndex == index ? 'c-black' : 'c-gray'"
      >
        {{ item.text }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Menuu",
  data: () => ({
    menuData: [
      {
        text: "朝阳红迹",
        pagePath: "About",
        icon: require("../assets/icon/map.svg"),
        selIcon: require("../assets/icon/sel-map.svg"),
      },
      {
        text: "朝阳趣研",
        pagePath: "Index",
        icon: require("../assets/icon/guide.svg"),
        selIcon: require("../assets/icon/sel-guide.svg"),
      },
      {
        text: "个人",
        pagePath: "Mine",
        icon: require("../assets/icon/user.svg"),
        selIcon: require("../assets/icon/sel-user.svg"),
      },
    ],
  }),
  computed: {
    zIndex() {
      return this.$store.state.menuIndex;
    },
  },
  methods: {
    switchRoute(item) {
      console.log(this.$route.name, item.pagePath);
      if (this.$route.name != item.pagePath) {
        this.$router.push({
          name: item.pagePath,
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.menu-list {
  box-shadow: 0px -2px 4px 0px rgba(0, 0, 0, 0.05);
}
.menu-icon {
  width: 22px;
  height: 22px;
}
</style>
